import { Injectable } from "@angular/core";
import { LogUpload } from "../utils/log-upload";
import { wsService } from "./ws.service";
import { generateMessage } from "../utils/messages";
import { TrsEventsService } from "./trsevents.service";
import { ISupervisorPreferenceRequestPayload } from "../interfaces/messages";
import { BehaviorSubject } from "rxjs";

export type SupervisorPreference = "LAST_SELECTED_THEME" | "LAST_MAXIMIZED_WIDGET";
export type Themes = 'light' | 'dark';
export type Widgets = 'EventHistory' | 'EventCount' | 'Chat' | 'None';

@Injectable()
export class SupervisorService {
    logUploader: LogUpload = new LogUpload("SupervisorService");

    private _preferences: { [key: string]: string } = {};
    selectedTheme$ = new BehaviorSubject<Themes>('light');
    maximizedWidget$ = new BehaviorSubject<Widgets>('None');

    constructor(private _wsService: wsService, private trsService: TrsEventsService) { }

    UpdatePreferences = (preferences: { [key: string]: string } | null): void => {
        if (preferences != null && Object.entries(preferences).length > 0) {
            this._preferences = preferences;

            if (this._preferences["LAST_SELECTED_THEME"] != null && this.selectedTheme$.value !== this._preferences["LAST_SELECTED_THEME"])
                this.selectedTheme$.next(this._preferences["LAST_SELECTED_THEME"] as Themes);
            if (this._preferences["LAST_MAXIMIZED_WIDGET"] != null && this.maximizedWidget$.value !== this._preferences["LAST_MAXIMIZED_WIDGET"])
                this.maximizedWidget$.next(this._preferences["LAST_MAXIMIZED_WIDGET"] as Widgets);
        }
    }

    SetPreference = (preference: SupervisorPreference, value: string): void => {
        this._preferences[preference] = value;
        const payload: ISupervisorPreferenceRequestPayload = {
            EventName: "SAVESUPERVISORPREFERENCES",
            SupervisorLanId: this.trsService.supervisorId,
            Preferences: { [preference]: value },
        };
        this._wsService.sendMessage(JSON.stringify(generateMessage("TRSSESSION", "", payload, this.trsService)));
    }

    GetPreference = (preferenceName: string): string | null => this._preferences[preferenceName];

    SetTheme = (selectedTheme: Themes): void => {
        if (this.selectedTheme$.value !== selectedTheme) {
            this.selectedTheme$.next(selectedTheme);
            this.SetPreference("LAST_SELECTED_THEME", selectedTheme);
        }
    }

    ToggleLastMaximizedWidget = (selectedWidget: Widgets): void => {
        if (this.maximizedWidget$.value !== selectedWidget) {
            this.maximizedWidget$.next(selectedWidget);
            this.SetPreference("LAST_MAXIMIZED_WIDGET", selectedWidget);
        }
        else {
            this.maximizedWidget$.next('None');
            this.SetPreference("LAST_MAXIMIZED_WIDGET", 'None');
        }
    }
}